<template>
  <div id="LangindAgenciesMobile">
    <div class="window_closer" @click="hide()">
      <font-awesome-icon class="icon" icon="arrow-right" />
    </div>

      <div style="margin-top: 50px; width: auto;">
        <div class="form-button mx-3">
          <input
            type="search"
            v-model="filter.search_keyword"
            placeholder="Search..."
          />
          <button type="submit" @click="searchAfterPause">Search</button>
        </div>
      </div>

    <div class="right" v-show="loading">
      <div class="section-loader">
        <img src="/loader-circle.gif" alt="" />
        <span>{{ $t("Loading") }}</span>
      </div>
    </div>
    <div class="right" v-show="!loading">
      <div class="recommendation" v-if="recommended_vendor">
        <div class="subtitle">- {{ $t("Recommended") }}</div>

        <div class="p-2" @click="openVendor(recommended_vendor.shortcode)">
          <Agency :Recommended="true" :Vendor="recommended_vendor" />
        </div>
      </div>

      <div class="vendors" v-if="vendors && vendors.length">
        <div class="subtitle">- {{ $t("YouCanAlsoFind") }}</div>

        <div
          class="p-2"
          v-for="item in vendors"
          :key="item.id"
          @click="openVendor(item.shortcode)"
        >
          <Agency :Recommended="false" :Vendor="item" />
        </div>
        
      </div>
      <vs-pagination
              @change="initPagePagination"
              :color="pColor"
              style="margin: 15px auto 90px auto; z-index: 0; position: relative;"
              :total="last_page"
              v-model="currentPage"
            ></vs-pagination>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Agency from "./components/Agency.vue";
import { vendorsService, controller } from "/src/_services";

import GmapCluster from "vue2-google-maps/dist/components/cluster";
let bodyStyles = document.body.style;

let timer = setTimeout(() => {}, 1);
export default {
  data: () => ({
    pColor: bodyStyles.getPropertyValue("--primary"),
    perPage: 6,
    last_page: 1,
    currentPage: 0,
    loading: false,
    loading_map: true,
    position: {
      lat: 36,
      lng: 10,
    },
    position_is_correct: false,
    filter: {
      search_keyword: null,
      page: 1,
    },

    vendors: null,
    recommended_vendor: null,
    markers: [],
    opened_info_window: 0,
  }),
  components: {
    Agency,
    GmapCluster,
  },
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          this.position.lat = position.coords.latitude;
          this.position.lng = position.coords.longitude;
          this.position_is_correct = true;
          this.currentPage = 1;
          // this.initPage();
          //    setInterval(() => {
          //    this.initPage();
          // }, "30000");
        }.bind(this),
        function () {
          this.position.lng = 10.1799885;
          this.position.lat = 36.7974303;
          this.position_is_correct = false;
          this.currentPage = 1;
          // this.initPage();
          // setInterval(() => {
          //  this.initPage();
          //  }, "30000");
        }.bind(this),
        { timeout: 5000 }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  },
  methods: {
    searchAfterPause() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        controller.abort();
        this.filterAgencies();
      }, 700);
    },
    openVendor(short_code) {
      this.$emit("openVendor", short_code);
      this.$emit("toggleButtonOn");
    },
    initPage() {
      this.loading = true;
      vendorsService
        .filter(
          {
            organization: this.Config.organization_id,
            lat: this.position.lat,
            lng: this.position.lng,
            keyword: this.filter.search_keyword,
            radius: this.Config.options.agencies_filter_radius,
            append: "rating",
            page: this.currentPage,
            perPage: this.perPage,
          }
        )
        .then(
          function (data) {
            this.vendors = data.data.data.map((obj) => {
              if (
                !obj.shortest_waiting_time ||
                obj.shortest_waiting_time == 0
              ) {
                obj.iconImgNumber = 0;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_1_person_until
              ) {
                obj.iconImgNumber = 1;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_2_persons_until
              ) {
                obj.iconImgNumber = 2;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_3_persons_until
              ) {
                obj.iconImgNumber = 3;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_4_persons_until
              ) {
                obj.iconImgNumber = 4;
              } else {
                obj.iconImgNumber = 5;
              }

              let time_to_wait_in_hours = Math.floor(
                obj.shortest_waiting_time / 60
              );
              let time_to_wait_in_minutes = obj.shortest_waiting_time % 60;
              obj.time_to_wait =
                (time_to_wait_in_hours > 0
                  ? time_to_wait_in_hours + "h "
                  : "") +
                time_to_wait_in_minutes +
                " min";

              return obj;
            });
            this.recommended_vendor = this.vendors[0];

            let i = 1;
            this.markers = [];
            this.vendors.map((vendor) => {
              this.markers.push({
                id: i,
                position: {
                  lat: Number(vendor.lat),
                  lng: Number(vendor.lng),
                },
                vendor,
              });
              i++;
              return vendor;
            });
            this.last_page = data.data.last_page;
          }.bind(this)
        )
        .finally(() => {
          this.loading = false;
          this.loading_map = false;
        });
    },
    initPagePagination(page) {
      this.loading = true;
      vendorsService
        .filter(
          {
            organization: this.Config.organization_id,
            lat: this.position.lat,
            lng: this.position.lng,
            keyword: this.filter.search_keyword,
            radius: this.Config.options.agencies_filter_radius,
            append: "rating",
            page: page,
            perPage: this.perPage,
          }
        )
        .then(
          function(data) {
            this.vendors = data.data.data.map((obj) => {
              if (
                !obj.shortest_waiting_time ||
                obj.shortest_waiting_time == 0
              ) {
                obj.iconImgNumber = 0;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_1_person_until
              ) {
                obj.iconImgNumber = 1;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_2_persons_until
              ) {
                obj.iconImgNumber = 2;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_3_persons_until
              ) {
                obj.iconImgNumber = 3;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_4_persons_until
              ) {
                obj.iconImgNumber = 4;
              } else {
                obj.iconImgNumber = 5;
              }

              let time_to_wait_in_hours = Math.floor(
                obj.shortest_waiting_time / 60
              );
              let time_to_wait_in_minutes = obj.shortest_waiting_time % 60;
              obj.time_to_wait =
                (time_to_wait_in_hours > 0
                  ? time_to_wait_in_hours + "h "
                  : "") +
                time_to_wait_in_minutes +
                " " +
                this.$t("Min");

              return obj;
            });
            this.recommended_vendor = this.vendors[0];

            let i = 1;
            this.markers = [];
            this.vendors.map((vendor) => {
              this.markers.push({
                id: i,
                position: {
                  lat: Number(vendor.lat),
                  lng: Number(vendor.lng),
                },
                vendor,
              });
              i++;
              return vendor;
            });
            this.last_page = data.data.last_page;
          }.bind(this)
        )
        .finally(() => {
          this.loading = false;
          this.loading_map = false;
        });
    },
    filterAgencies() {
      this.loading = true;
      vendorsService
        .filter(
          {
            organization: this.Config.organization_id,
            lat: this.position.lat,
            lng: this.position.lng,
            keyword: this.filter.search_keyword,
            radius: this.Config.options.agencies_filter_radius,
            append: "rating",
            perPage: this.perPage,
          }
        )
        .then(
          function(data) {
            this.vendors = data.data.data.map((obj) => {
              if (
                !obj.shortest_waiting_time ||
                obj.shortest_waiting_time == 0
              ) {
                obj.iconImgNumber = 0;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_1_person_until
              ) {
                obj.iconImgNumber = 1;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_2_persons_until
              ) {
                obj.iconImgNumber = 2;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_3_persons_until
              ) {
                obj.iconImgNumber = 3;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_4_persons_until
              ) {
                obj.iconImgNumber = 4;
              } else {
                obj.iconImgNumber = 5;
              }

              let time_to_wait_in_hours = Math.floor(
                obj.shortest_waiting_time / 60
              );
              let time_to_wait_in_minutes = obj.shortest_waiting_time % 60;
              obj.time_to_wait =
                (time_to_wait_in_hours > 0
                  ? time_to_wait_in_hours + "h "
                  : "") +
                time_to_wait_in_minutes +
                " " +
                this.$t("Min");

              return obj;
            });
            this.recommended_vendor = this.vendors[0];

            let i = 1;
            this.markers = [];
            this.vendors.map((vendor) => {
              this.markers.push({
                id: i,
                position: {
                  lat: Number(vendor.lat),
                  lng: Number(vendor.lng),
                },
                vendor,
              });
              i++;
              return vendor;
            });
            this.last_page = data.data.last_page;
          }.bind(this)
        )
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false;
          this.loading_map = false;
        });
    },
    show() {
      $("#LangindAgenciesMobile").css("margin-left", "0");
    },
    hide() {
      $("#LangindAgenciesMobile").css("margin-left", "100%");
      this.$emit("removeBorder");
    },
  },
};
</script>

<style lang="scss" scoped>
#LangindAgenciesMobile {
  width: 100vw;
  height: 100%;
  overflow: scroll !important;
  position: absolute;
  top: 0;
  transition: 0.5s;
  background: #fff;

  margin-left: 100%;
  .window_closer {
    font-size: 15px;
    color: #555;
    cursor: pointer;
    transition: 0.3s;
    float: right;
    margin-top: 10px;
    padding: 10px 20px 0 20px;
  }
  .window_closer:hover {
    transform: scale(1.02);
  }
  .section-loader {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
      width: 50px;
    }
    span {
      display: block;
      font-size: 15px;
      margin-top: 15px;
    }
  }
  .right {
    padding: 0 20px;
    // overflow-y: scroll !important;
    .subtitle {
      margin-top: 20px;
      font-size: 17px;
      color: #555;
      letter-spacing: 2px;
    }
  }

  .form-button {
    color: #555;
    display: flex;
    padding: 2px;
    border: 1px solid currentColor;
    border-radius: 5px;
  }

  input[type="search"] {
    border: none;
    width: 100%;
    background: transparent;
    margin: 0;
    padding: 7px 8px;
    font-size: 14px;
    color: inherit;
    border: 1px solid transparent;
    border-radius: inherit;
  }

  input[type="search"]::placeholder {
    color: #bbb;
  }

  button[type="submit"] {
    text-indent: -999px;
    overflow: hidden;
    width: 40px;
    padding: 0;
    margin: 0;
    border: 1px solid transparent;
    border-radius: inherit;
    background: var(--primary) url("/search.png") no-repeat center;
    background-size: 22px;
    cursor: pointer;
  }

  button[type="submit"]:hover {
    opacity: 0.8;
  }

  button[type="submit"]:focus,
  input[type="search"]:focus {
    box-shadow: 0 0 3px 0 #1183d6;
    border-color: #1183d6;
    outline: none;
  }
}
</style>